'use client';
import React from 'react';
import styles from './tabs.module.scss';
import { analyticsConstants } from '../constants';
import { ProgressiveLeasing } from './ProgressiveLeasing/progressive-leasing-estimator';
import AffirmContent from './affirm-content';

type FinancingOffer = {
  index: number;
  name: string;
  url: string;
};

type LowerCaseTypes = {
  synchrony: string;
  affirm: string;
  progresive: string;
};

interface TabsProps {
  filteredOffers: FinancingOffer[];
  lowerCaseTypes: LowerCaseTypes;
  activeTab: number;
  setActiveTab: (activeTab: number) => void;
  syfTabBody: React.ReactNode;
  progressiveTotalAmount?: number;
  balanceAmount?: number;
}

const Tabs: React.FC<TabsProps> = ({
  filteredOffers,
  lowerCaseTypes,
  activeTab,
  setActiveTab,
  syfTabBody,
  progressiveTotalAmount,
  balanceAmount,
}) => {
  if (filteredOffers.length === 0) {
    return null;
  }

  return (
    <section
      className={`${activeTab === 0 ? styles.showScroll : ''} ${styles.wrapper}`}
    >
      <div className={styles.tab}>
        {filteredOffers.map((offer) => (
          <button
            tabIndex={0}
            key={offer.index}
            id={`${analyticsConstants.pageName}-tabs-${offer.name}`}
            className={`${styles.tablink} ${activeTab === offer.index ? styles.active : ''} ${styles[offer.name]} ${offer.index === 1 ? styles.fullWidth : ''}`}
            onClick={() => setActiveTab(offer.index)}
            role="tab"
            aria-selected={activeTab === offer.index}
          >
            <img src={offer.url} alt={offer.name} />
          </button>
        ))}
      </div>

      {filteredOffers.map((offer) => (
        <div
          key={offer.index}
          id={`${offer.index}`}
          className={`${activeTab === offer.index ? styles.active : ''} ${styles.offerTab}`}
        >
          {offer.name === lowerCaseTypes.synchrony && <>{syfTabBody}</>}
          {offer.name === lowerCaseTypes.affirm && (
            <AffirmContent total={balanceAmount || 0} />
          )}
          {offer.name === lowerCaseTypes.progresive && (
            <ProgressiveLeasing price={progressiveTotalAmount || 0} />
          )}
        </div>
      ))}
    </section>
  );
};

export default Tabs;
